import React, { FunctionComponent, useState } from "react";
import { useParams } from "react-router-dom";
import { EditProfileForm } from "../EditProfileForm";
import { CustomTabs } from "../CustomTabs";
import { QueriesPanel } from "../QueriesPanel";
import { DashboardPanel } from "../DashboardPanel";
import { EditDealerInfoForm } from "../EditDealerInfoForm";
import { ProductPanel } from "../ProductPanel";
import { User } from "../../model/User";

export const EditProfileTabs: FunctionComponent = (props) => {
  const user = new User();
  const disableQueries = user.HasForbiddenAccess("Can Read Queries Tab");
  const disableDashboard = user.HasForbiddenAccess(
    "Can Read Dashboard Tables Tab",
  );
  const { username } = useParams();

  return (
    <CustomTabs
      tabLabels={[
        { title: "Edit Profile", disabled: false },
        { title: "Queries", disabled: disableQueries },
        { title: "Dashboard", disabled: disableDashboard },
        { title: "Integrations", disabled: false },
        //{ title: "Dealer Info", disabled: true },
        { title: "Product", disabled: false },
      ]}
      tabComponents={[
        <EditProfileForm username={username} />,
        <QueriesPanel username={username} />,
        <DashboardPanel username={username} />,
        <EditProfileForm isIntegrationsEnabled username={username} />,
        //<EditDealerInfoForm username={username!} />,
        <ProductPanel username={username!} />,
      ]}
    />
  );
};
